<div
  #container
  class="chart-container">
  <ngx-charts-area-chart
    #chartRef
    [results]="chartData"
    [legend]="false"
    [curve]="curve"
    [customColors]="customColors"
    [showXAxisLabel]="false"
    [showYAxisLabel]="false"
    [xAxis]="true"
    [yAxis]="true"
    [gradient]="true"
    [showGridLines]="false"
    [yScaleMin]="min"
    [yScaleMax]="max"
    [wrapTicks]="true"
    [xAxisTickFormatting]="formatTime"
    [yAxisTickFormatting]="formatTemp">
    <ng-template #tooltipTemplate let-model="model">
      @if (getTooltipPoint(model); as point) {
        <div class="chart-tooltip">
          <div class="chart-tooltip__label">{{ formatTooltipDate(point) }}</div>
          <div>{{ 'weather.temperature' | translate }}: {{ point.value | localizedNumber:'1.0-0' }} °C</div>
        </div>
      }
    </ng-template>

    <ng-template #seriesTooltipTemplate let-model="model">
      @if (getTooltipPoint(model); as point) {
        <div class="chart-tooltip">
          <div class="chart-tooltip__label">{{ formatTooltipDate(point) }}</div>
          <div>{{ 'weather.temperature' | translate }}: {{ point.value | localizedNumber:'1.0-0' }} °C</div>
        </div>
      }
    </ng-template>
  </ngx-charts-area-chart>

  @if (xScale && yScale && xMin && xMax && min < 0) {
    <svg
      class="null-overlay"
      [attr.width]="width"
      [attr.height]="height">
      <line
        [attr.x1]="xScale(xMin) + 55"
        [attr.x2]="xScale(xMax) + 55"
        [attr.y1]="yScale(0) + 10"
        [attr.y2]="yScale(0) + 10"
        stroke="gray"
        stroke-width="1"
        stroke-dasharray="4,2"
      />
    </svg>
  }

  @if (xScale && yScale) {
    <div class="icon-overlay">
      <div
        *ngFor="let point of chartData[0].series"
        class="weather-icon small"
        [class]="point.icon"
        [style.left.px]="xScale(point.name) + 40"
        [style.top.px]="yScale(point.value) - 30">
      </div>
    </div>
  }
</div>
